import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { routes } from '../../../constants/routes';
import { useNavbarContext } from '../../../contexts/NavbarProvider';
import CollapsibleSideNavButton from '../Buttons/CollapsibleSideNavButton';
import SideNavButton from '../Buttons/SideNavButton';

const MobileSideNavbar = () => {
  // integration of custom hooks here
  const { showMobileNavbar, setShowMobileNavbar } = useNavbarContext();

  // rendering mobile side navbar component here
  return (
    <motion.div
      initial={{ opacity: 0, display: 'none' }}
      animate={
        showMobileNavbar
          ? { opacity: 1, display: 'block' }
          : { opacity: 0, transitionEnd: { display: 'none' } }
      }
      onClick={() => setShowMobileNavbar(false)}
      className='fixed top-0 left-0 h-full w-screen bg-white/45 backdrop-blur-md z-[10000]'
    >
      <motion.aside
        initial={{ x: -260 }}
        animate={showMobileNavbar ? { x: 0 } : { x: -260 }}
        className='fixed top-0 w-[260px] h-screen bg-legal-dark-blue py-3 pt-5 shadow-academia-sm z-30 overflow-y-auto overflow-x-hidden'
      >
        <div className='flex flex-col items-center justify-center'>
          <Link
            to={'/dashboard'}
            className='italic text-base-white block w-[150px] text-xl hover:opacity-60 active:scale-95 duration-300'
          >
            <h1>Global Academia</h1>
          </Link>
        </div>

        <nav className='mt-10 italic'>
          {routes.map((route, index) =>
            route.subRoutes ? (
              <CollapsibleSideNavButton
                key={index}
                route={route}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <SideNavButton key={index} route={route} />
            )
          )}
        </nav>
      </motion.aside>
    </motion.div>
  );
};

export default MobileSideNavbar;
